module.exports = __webpack_public_path__ + "static/media/add_circle.1dc481fa.svg";